export const SPRINTS_MESSAGES = {
  // Page title and header
  pageTitle: "Sprints: Optimize your metabolic-fertility",
  tabTitle: "Sprints",

  // Introduction section
  introduction: {
    title: "Introducing the Sprints mobile app",
    description:
      "Sprints is Carrot's exclusive metabolic-fertility program designed to help members and their partners overcome fertility challenges caused by metabolic disorders.",
    availability: "*Available on iOS and Android",
    clinicalBacking:
      "Backed by clinical research and curated by experts, our comprehensive daily program is individually tailored to help you make healthier choices in four key areas that affect fertility health: nutrition, movement, sleep, and stress management.",
    goalDescription:
      "Sprints is designed to help you achieve your fertility goals and lay the foundation for a healthy pregnancy. The Sprints mobile app is included in your Carrot benefit and offered at no cost to you."
  },

  // How Sprints helps section
  howItHelps: {
    title: "How Sprints can help you get pregnant",
    description:
      "Sprints is a daily, guided program designed to support you in four critical areas that directly impact metabolic-fertility:"
  },

  // Why metabolic-fertility matters section
  whyItMatters: {
    title: "Why does metabolic-fertility matter when trying to get pregnant?",
    description:
      "The evidence is clear. Studies show that by improving your metabolic health you can positively impact your fertility health and pregnancy outcomes."
  },

  // Telemedicine and GLP-1s section
  telemedicine: {
    title: "Access to telemedicine and GLP-1s",
    description:
      "Whether you're just getting started or looking to overcome fertility challenges, you'll have access to Carrot's specialized Care Team — including experts in metabolic-fertility — along with telemedicine support and weight loss medications, including GLP-1s, when appropriate.<br/><br/>Telemedicine support for Sprints is only available for individuals intending to carry a pregnancy. Providers will work with you to determine the best treatment path, including medications if appropriate.",
    glp1CoverageNote:
      "\\* You may be able to use your Carrot funds for telemedicine and medications not covered by insurance. Check your <link>benefit guide</link> for details on coverage.",
    insuranceCoverageNote:
      "\\* Telemedicine and medications may be covered by your insurance. Check your <link>benefit guide</link> for details."
  },

  // Call to action section
  callToAction: {
    title: "Ready to boost your metabolic-fertility?",
    description:
      "Download the app and start your hyperpersonalized Sprint toward pregnancy with expert guidance every step of the way.",
    availability: "*Available on iOS and Android",
    learnMore: "Learn more in your benefit guide",
    getStarted: "Get started"
  },

  // Download buttons for app stores
  downloadButtons: {
    iosAriaLabel: "Download on the App Store",
    googlePlayAriaLabel: "Get it on Google Play"
  },

  // Designed by section
  designedBy: {
    title: "Designed by leading fertility specialists",
    asimaAhmad: {
      name: "Asima Ahmad",
      title: "MD, MPH, FACOG, DABOM",
      description:
        "Co-founder and Chief Medical Officer of Carrot Fertility; a practicing specialist who is triple board-certified in reproductive endocrinology and infertility, obstetrics and gynecology (OB/GYN), and obesity medicine"
    },
    richardLegro: {
      name: "Richard Legro",
      title: "MD, FACOG",
      description:
        "Carrot medical advisor, double board-certified OB/GYN, REI and subspecialty-certified in reproductive endocrinology and infertility, with specialization in lifestyle modification and treatments to improve human reproductive function"
    },
    javineMcLaughlin: {
      name: "Javine McLaughlin",
      title: "MD, FACOG, DABOM, MSCP",
      description:
        "VP of Clinical Operations at Carrot Fertility; double board-certified OB/GYN and obesity medicine physician; certified menopause practitioner with the Menopause Society (MSCP)"
    }
  },

  // Testing tools (for test users only)
  testingTools: {
    button: "Testing tools",
    title: "Temporary tools to allow for testing dynamic content based on company configuration",
    showTelemedicine: "Show Telemedicine content",
    showGLP1: "Show GLP-1 content",
    update: "Update"
  },

  // Carousel section
  carousel: {
    nextAriaLabel: "Go to next carousel slide",
    previousAriaLabel: "Go to previous carousel slide",
    nutrition: {
      description: "<b>Nutrition —</b> Fuel your fertility with guidance from experts on diet and metabolic health"
    },
    movement: {
      description: "<b>Movement —</b> Get support setting goals and incorporating movement into your day"
    },
    sleep: {
      description: "<b>Sleep —</b> Rest smarter to support hormone balance and healing"
    },
    stress: {
      description:
        "<b>Stress management —</b> Build resilience and learn to navigate the emotional ups and downs of trying to get pregnant"
    },
    telemedicine: {
      description:
        "<b>Telemedicine support —</b> Connect with telemedicine providers who can prescribe weight loss medications like GLP-1s when appropriate"
    }
  },

  // Getting started section
  gettingStarted: {
    title: "Get started with Sprints to:",
    boostFertility: {
      title: "Boost fertility",
      description:
        "Women with a BMI over 25 may take longer to become pregnant — improving metabolic health may help avoid or reduce the need for IVF."
    },
    fewerFertilityTreatments: {
      title: "Fewer fertility treatments and medications",
      description:
        "Addressing metabolic issues may lower the number of IVF cycles needed and the amount of medication required per cycle."
    },
    supportMaleFertility: {
      title: "Support male fertility",
      description: "Better nutrition and exercise can improve sperm count and quality."
    },
    healthierPregnancyOutcomes: {
      title: "Healthier pregnancy outcomes",
      description: "Improved metabolic-fertility reduces potential future complications for both parent and baby."
    }
  }
}
